const SESSION_KEY = 'chemrobotics_session';
const AUTH_API_BASE = (
  process.env.REACT_APP_AUTH_API_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  'https://apidev.chemrobotics.com'
).replace(/\/$/, '');
// This is the public development key published in the supplied API documentation.
// Override it from .env for another environment.
const API_KEY = process.env.REACT_APP_CHEMROBOTICS_API_KEY || 'AzI0f64MzcpKE1rNmlJzTfb8PTfcdQ9y';
const PLATFORM = process.env.REACT_APP_CHEMROBOTICS_PLATFORM || 'PharmVetPat';

const CREDENTIALS = {
  admin: {
    username: process.env.REACT_APP_ADMIN_USERNAME || 'admin',
    password: process.env.REACT_APP_ADMIN_PASSWORD || 'chemrobotics123',
  },
  user: {
    username: process.env.REACT_APP_USER_USERNAME || 'user',
    password: process.env.REACT_APP_USER_PASSWORD || 'chemrobotics123',
  },
};

function saveSession(session) {
  // localStorage is shared by all tabs on this domain. This keeps one active
  // account across tabs instead of allowing a different user in each tab.
  localStorage.setItem(SESSION_KEY, JSON.stringify({ ...session, at: Date.now() }));
}

async function loginUser(email, password) {
  const body = new URLSearchParams({ email, password });
  let response;

  try {
    response = await fetch(`${AUTH_API_BASE}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'api-key': API_KEY,
        platform: PLATFORM,
      },
      body: body.toString(),
    });
  } catch {
    throw new Error('Unable to reach the login service. Please try again.');
  }

  let payload = {};
  try {
    payload = await response.json();
  } catch {
    // Keep the fallback message below if the server returns an invalid response.
  }

  const user = payload?.data?.user_info;
  if (!response.ok || payload?.status === false || !user) {
    throw new Error(
      payload?.message || payload?.errors?.[0] || 'Invalid email or password.'
    );
  }

  // ChatBot APIs require this token in the `access-token` header. Do not
  // create a fake session when the login service has not issued one.
  const accessToken = user.auth_token || user.token || payload?.data?.auth_token || payload?.data?.token || payload?.auth_token || payload?.token || null;
  if (!accessToken) {
    throw new Error('Login succeeded, but the API did not return an access token. Please contact the API team.');
  }

  saveSession({
    role: 'user',
    user: user.name || user.email || email,
    email: user.email || email,
    token: accessToken,
    authKey: user.auth_key || null,
    userInfo: user,
  });
  return true;
}

export async function login(role, username, password) {
  if (role === 'user') {
    return loginUser(username, password);
  }

  const credentials = CREDENTIALS[role];
  if (!credentials || username !== credentials.username || password !== credentials.password) {
    return false;
  }

  saveSession({ user: username, role });
  return true;
}

export function logout() {
  localStorage.removeItem(SESSION_KEY);
}

export function getSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function isLoggedInAs(role) {
  return getSession()?.role === role;
}

export function getAccessToken() {
  return getSession()?.token || null;
}

export function getAuthenticatedHeaders() {
  const token = getAccessToken();
  return {
    'api-key': API_KEY,
    platform: PLATFORM,
    ...(token ? { 'access-token': token } : {}),
  };
}
